/**Bug #732 - List and choose user's saved cards @author Jithin Kuriakose @date 24Jan2022 */
import {
    InputItem,
    Input,
} from "components";

interface Props {
    preFix?: any;
    keyName: any;
    value?: any;
    rules?: any;
    onChange?: any;
}

const defaultProps = {
    
};
var inputProps = {
    className: ''
};

const HiddenInput = (props: Props) => {
    if(props.value) {
        inputProps['value'] =  props.value;
    }
    if(props.onChange) {
        inputProps['onChange'] =  props.onChange;
    }

    return (
        <InputItem
            name={
                props?.preFix || props?.preFix === 0
                    ? [props?.preFix, props?.keyName]
                    : props?.keyName
            }
            className="d-none"
            rules={props?.rules ? [...props.rules] : ""}
            valuePropName="hidden"
        >
            <Input
                type="hidden"
                {...inputProps}
            />
        </InputItem>
    );
};

HiddenInput.defaultProps = defaultProps;
export default HiddenInput;
